import React from 'react';
import PropTypes from 'prop-types';
import { MText } from '../../atoms/MText';

import { PriceDetailsCon, DeductedPrice, Discount } from './skin';

export default function PriceDetails({
  offerPrice,
  price,
  off,
  offerPriceStyles = {},
  priceStyles = {},
  offStyles = {},
  ai = 'baseline',
  flexWrap = 'wrap',
  textAlignment = 'left',
  fontFamily = 'inherit',
  margin = '0px',
  padding = '0px',
  width = 'auto',
  isInline = false,
  isDiscountDisabled,
  hideOfferPrice = false,
  showFree = false,
  className = '',
  isTotalOfferPriceAndTotalPriceSame = false,
}) {
  return (
    <PriceDetailsCon
      isInline={isInline}
      gap="4px"
      ai={ai}
      flexWrap={flexWrap}
      textAlignment={textAlignment}
      fontFamily={fontFamily}
      padding={padding}
      margin={margin}
      width={width}
      className={`${className} mr-price-con`}
    >
      {!hideOfferPrice && (
        <MText {...offerPriceStyles} className="mr-price-con__offer-price">
          {offerPrice}
        </MText>
      )}
      {!isDiscountDisabled &&
        !showFree &&
        !isTotalOfferPriceAndTotalPriceSame && (
          <>
            <DeductedPrice
              {...priceStyles}
              isStrikeThrough={!hideOfferPrice}
              className="mr-price-con__price"
            >
              {price}
            </DeductedPrice>
            <Discount
              {...offStyles}
              isWrap={flexWrap === 'wrap'}
              className="mr-price-con__off"
            >
              {off}
            </Discount>
          </>
        )}
    </PriceDetailsCon>
  );
}

PriceDetails.propTypes = {
  hideOfferPrice: PropTypes.bool,
  isTotalOfferPriceAndTotalPriceSame: PropTypes.bool,
  price: PropTypes.string,
};
